import { Button, Create, CreateButton, Datagrid, DateField, ExportButton, FilterButton, Link, List, NumberField, ReferenceField, ReferenceInput, SearchInput, SelectInput, TextField, TopToolbar, maxValue, minValue, required } from 'react-admin';
import { DateInput, Edit, NumberInput, SimpleForm, TextInput } from 'react-admin';
import { url_download_template_piket } from '../constant/constant';
import { MyDateInput } from '../constant/MyDateInput';
import { MonthPicker } from '@mui/x-date-pickers';

const PiketListActions = () => (
    <TopToolbar>
        <Link to="/jadwal_piket_ppid/import" style={{textDecoration: "none", display: "inline-flex"}}><Button variant="outlined" label='Import Template'/></Link>
        <a style={{textDecoration: "none", display: "inline-flex"}} href={url_download_template_piket} download><Button variant="contained" label='Download Template'/></a>
        {/* <FilterButton /> */}
        <CreateButton style={{display: "inline-flex"}} />
        <ExportButton />
    </TopToolbar>
);

export const Jadwal_ppid_piketList = () => (
    <List filters={piketFilters} actions={<PiketListActions/>} filterDefaultValues={{"tanggal": new Date().toLocaleDateString("en-CA", {year:"numeric", month: "2-digit"})}}>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <DateField source="tanggal" />
            <NumberField source="sesi" />
            {/* <NumberField source="petugas1" /> */}
            <ReferenceField label="Nama Petugas 1" source="petugas1" reference="petugas_pst" link={false} >
                <TextField source="nama" />
            </ReferenceField>
            
            <DateField source="date_created" />
        </Datagrid>
    </List>
);


export const Jadwal_ppid_piketEdit = () => (
    <Edit>
        <SimpleForm>
            {/* <TextInput source="id" /> */}
            <DateInput source="tanggal" />
            <NumberInput source="sesi" validate={[minValue(1), maxValue(2)]} />
            {/* <NumberInput source="petugas1" /> */}
            {/* <ReferenceInput label="Nama Petugas 1" source="petugas1" reference="petugas_pst" link={false} >
                <SelectInput source="nama" />
            </ReferenceInput> */}

            <ReferenceInput source="petugas1" reference="petugas_pst" sort={{ field: 'nama', order: 'ASC' }} perPage={100}>
                <SelectInput label="Nama Petugas 1" optionText="nama" validate={[required()]} />
            </ReferenceInput>
            {/* <NumberInput source="petugas2" />
            <NumberInput source="petugas3" />
            <NumberInput source="petugas4" /> */}
            
            <DateInput source="date_created" disabled />
        </SimpleForm>
    </Edit>
);

export const Jadwal_ppid_piketCreate = () => (
    <Create>
        <SimpleForm>
            {/* <TextInput source="id" /> */}
            <DateInput source="tanggal" />
            <NumberInput source="sesi" validate={[minValue(1), maxValue(2)]} />
            {/* <NumberInput source="petugas1" /> */}
            {/* <ReferenceInput label="Nama Petugas 1" source="petugas1" reference="petugas_pst" link={false} >
                <SelectInput source="nama" />
            </ReferenceInput> */}

            <ReferenceInput source="petugas1" reference="petugas_pst">
                <SelectInput label="Nama Petugas 1" optionText="nama" validate={[required()]} />
            </ReferenceInput>
            {/* <NumberInput source="petugas2" />
            <NumberInput source="petugas3" />
            <NumberInput source="petugas4" /> */}
            
            {/* <DateInput source="date_created" disabled /> */}
        </SimpleForm>
    </Create>
);

const piketFilters = [
    // <SearchInput source="tanggal" alwaysOn />,
    <MyDateInput source="tanggal" parse={val => val.substring(0,7)} alwaysOn />,
    // <DateInput source="tanggal" parse={val => getStringFromDate(val).substring(0,10)} inputFormat="dd MMMM yyyy" alwaysOn />,
];